import { CheckCircle2 } from "lucide-react"
import { Job } from "@/types/jobs"

/**
 * Displays the summary of subscriber import results
 * Shows success message or partial success details
 */
export function SubscriberImportSummary({
  job,
  subscriberSuccessCount,
  hasPartialSuccess,
}: {
  job: Job
  subscriberSuccessCount: number
  hasPartialSuccess: boolean
}) {
  return (
    <div className="space-y-3">
      <h3 className="text-base font-medium">Import Summary</h3>
      {hasPartialSuccess ? (
        <div className="flex items-start gap-2">
          <div className="flex-shrink-0 w-5 h-5 flex items-center justify-center">
            <CheckCircle2 className="h-4 w-4 text-primary" />
          </div>
          <p className="text-sm text-muted-foreground leading-5 whitespace-pre-line">
            {job.errorMessagePublic ||
              `Successfully imported ${subscriberSuccessCount} subscribers.`}
          </p>
        </div>
      ) : (
        <div className="flex items-start gap-2">
          <div className="flex-shrink-0 w-5 h-5 flex items-center justify-center">
            <CheckCircle2 className="h-4 w-4 text-primary" />
          </div>
          <p className="text-sm text-muted-foreground leading-5">
            {subscriberSuccessCount > 0
              ? `${subscriberSuccessCount} subscribers were successfully imported.`
              : "Import complete. All subscribers were processed successfully."}
          </p>
        </div>
      )}
    </div>
  )
}
